import styled from 'styled-components';

export const StyledStatisticsCardSkeleton = styled.div`
  .statistics-card-skeleton {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;
